import { useEffect, useRef, useState } from "react";

/** Pavé de signature tactile (doigt ou souris) → PNG en data URL. */
export function SignaturePad({ onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef({ x: 0, y: 0 });
  const [empty, setEmpty] = useState(true);
  useEffect(() => { const ctx = canvasRef.current.getContext("2d"); ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.strokeStyle = "#111"; }, []);
  const pos = (e) => { const r = canvasRef.current.getBoundingClientRect(); const t = e.touches ? e.touches[0] : e; const sx = canvasRef.current.width / r.width; const sy = canvasRef.current.height / r.height; return { x: (t.clientX - r.left) * sx, y: (t.clientY - r.top) * sy }; };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = pos(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d"); const p = pos(e);
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke(); last.current = p;
    if (empty) setEmpty(false);
    onChange(canvasRef.current.toDataURL("image/png"));
  };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(""); };
  return (
    <div>
      <canvas ref={canvasRef} width={520} height={170} data-testid="signature-canvas" className="w-full border-2 border-dashed border-zinc-400 rounded-lg bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end} onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <div className="flex justify-between items-center mt-2">
        <span className="text-xs text-zinc-500">{empty ? "Signez ci-dessus avec le doigt" : "Signature saisie ✓"}</span>
        <button type="button" onClick={clear} data-testid="signature-clear" className="text-xs text-zinc-500 hover:text-red-500 underline">Effacer</button>
      </div>
    </div>
  );
}
